import { BenefitListItem, PaginatedResponse, SubmissionBenefitListType } from '@app-types';
import axios from './axios';

const getListItems = (type: SubmissionBenefitListType) => axios.get<PaginatedResponse<BenefitListItem>>(`/lists/${type}`);

export default { getListItems };
